/**
 * Unit-conversion helpers for working in millimetres.
 *
 * ‣ By default we assume **1 Three-space unit = 1 metre (1000 mm)**.
 *   Change `UNITS_PER_MM` if you want a different global scale.
 *
 * ‣  Use `mm(value)` whenever you supply a distance to Three.js.
 *    The intent is explicit and the code stays self-documenting.
 *
 * ‣  Use `toMM(value)` to convert a Three-space measurement back
 *    into millimetres (e.g. for read-outs or exporting data).
 */

export const UNITS_PER_MM = 0.01;          // 1 mm → 0.001 scene units
export const MM_PER_UNIT = 1 / UNITS_PER_MM; // 1 scene unit → 1000 mm

/** millimetres → scene units */
export function mm(value: number): number {
  return value * UNITS_PER_MM;
}

/** scene units → millimetres */
export function toMM(value: number): number {
  return value * MM_PER_UNIT;
}
